import { Skeleton } from "@progress/kendo-react-indicators";
import "./dashboard-skeletons.scss";

export const DashboardGridSkeletonRectangle = ({width = '1338px', noShadow = false}) => {
  return (
    <div className={`skeleton-dashboard-container new-dashboard table-wrapper  ${noShadow ? '' : 'task-skeleton-container-shadow'}`}  style={{  width: width, maxWidth: width }}>
      <Skeleton
                  shape="rectangle"
                  className="skeleton-rectangle-block-dashboard"
                  animation={{ type: "wave" }}
                  data-testid="skeleton-rectangle-dashboard"
                />
    </div>
  );
};